import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'longNameFormatter'
})
export class LongNameFormatterPipe implements PipeTransform {
	public transform(value: string, maxCharacters: number): string {
		return value?.length < maxCharacters ? value : value.substring(0, maxCharacters) + '...';
	}
}
